// extracted by mini-css-extract-plugin
export default {"cardRow":"Options_cardRow__EEDyP","linkCard":"Options_linkCard__W9mgT","linkText":"Options_linkText__1xa+J"};